import { useGlobal } from '@rcg/ui-react';

const useDictionary = (dictionary) => {
  const { renderContent } = useGlobal();

  return (entry) => {
    // eslint-disable-next-line no-prototype-builtins
    if (dictionary.hasOwnProperty(entry)) {
      return renderContent(dictionary[entry].key, dictionary[entry].defaultValue);
    }

    return null;
  };
};

export default useDictionary;
